import { gql } from "@apollo/client";

export const GET_SALON_BY_ID = gql`
  query GetSalonById($id: ID!) {
    getSalonById(id: $id) {
      id
      vendor_id
      staff_id
      salon_name
      phone
      alternate_phone
      gender_served
      business_type_ids
      seats
      availability
      todays_availability
      salon_logo
      images
      amenities
      description
      salon_inactive
      establishment_date
      executive_code
      address_id
      created_at
      updated_at
      address {
        formatted_address
        latitude
        longitude
        area
        city
        zip
      }
    average_ratings
    total_ratings
    recent_ratings {
      id
      rating
      review
      created_at
      customer {
        id
        name
        image
      }
    }
    }
  }
`;